import { createContext, useContext, useState } from "react";

// Create Context
const BottlerSelectionContext = createContext();

// Context Provider Component
export const BottlerSelectionProvider = ({ children }) => {
    const [selectedData, setSelectedData] = useState([]);

    return (
        <BottlerSelectionContext.Provider value={{ selectedData, setSelectedData }}>
            {children}
        </BottlerSelectionContext.Provider>
    );
};

// Custom Hook for easy access
export const useBottlerSelection = () => useContext(BottlerSelectionContext);
